import OneSignal, { NotificationClickEvent } from "@/lib/onesignal";
import { RouteName } from "@/lib/router/routes";
import getRouteForRun from "@/lib/utils/route/getRouteForRun";
import useAuthStore from "@/stores/useAuthStore";
import { NotificationType } from "@shared/lib/database/enum.types";
import { PendingNotification, RunAwardWinnerNotificationPayload, RunNotificationPayload, SubRequestNotificationPayload } from "@shared/lib/database/query.types";
import { storeToRefs } from "pinia";
import { onBeforeUnmount, onMounted, watch } from "vue";
import { useRouter } from "vue-router";

export default function () {
  const {
    currentUser,
  } = storeToRefs(useAuthStore());

  const router = useRouter();

  onMounted(() => {
    OneSignal.initialize(import.meta.env.VITE_ONESIGNAL_APP_ID);
    OneSignal.Notifications.addEventListener("click", handleNotificationClick);

    watch(currentUser, (newCurrentUser, oldCurrentUser) => {
      if (newCurrentUser) {
        OneSignal.login(newCurrentUser.id);
      } else if (oldCurrentUser) {
        OneSignal.logout();
      }
    }, {
      immediate: true,
    });
  });

  onBeforeUnmount(() => {
    OneSignal.Notifications.removeEventListener("click", handleNotificationClick);
  });

  function getRouteForNotification (notification: PendingNotification) {
    const {
      type,
      payload,
    } = notification;

    switch (type as NotificationType) {
      case "RunSummary":
      case "UpdatedStatuses":
      case "SubRequest":
      case "SubRequestApproval":
      case "RunAwardWinner":
        return getRouteForRun((payload as RunNotificationPayload | SubRequestNotificationPayload | RunAwardWinnerNotificationPayload).run_id);
      case "CrewRequest":
        return {
          name: RouteName.notifications,
        };
      case "CrewRequestApproval":
        return {
          name: RouteName.home,
        };
      case "RunVote":
        return {
          name: RouteName.runReview,
          params: {
            runId: (payload as RunNotificationPayload).run_id,
          },
        };
    }
  }

  function handleNotificationClick (e: NotificationClickEvent) {
    const route = getRouteForNotification(e.notification.additionalData as PendingNotification);

    if (route) router.push(route);
  }
}
